import React from "react"
import PropTypes from "prop-types"
import Modal from "react-bootstrap-modal"
import PlayerSelector from "../../player-selector"
import PriceButtons from "../../../containers/shop/reservation-price-buttons"

const Title = props => (<div className="shop-reservation__title">{props.text}</div>)

const ReservationButton = props => {
  function getButtonText() {
    if (!props.reservation) return ""
    
    if (props.reservation.isOpenGame) {
      return "Plei App Game"
    } else {
      return props.reservation.name
    }
  }

  return (
    <button className={`${props.isSelected ? "selected" : ""}`}
      onClick={props.onClick}>
        {getButtonText()}
    </button>
  )
}

const isCurrentHour = time => {
  const now = (new Date()).getTime()
  return ((time > now - 3600000) && (time < now))
}


class ReservationSelector extends React.Component {
  constructor(props) {
    super(props)
    this.scrollStorageKey = `${App.Vars.current_location}_shopReservationSelectorLeftScroll`
    this.scrollLeft = window.localStorage.getItem(this.scrollStorageKey)
    this.state = {
      isScrolling: false,
    }
    this.onScrollButtons = this.onScrollButtons.bind(this)
  }

  onScrollButtons(e) {
    if (this.scrollLeft == this.scrollingElement.scrollLeft) {
      this.setState({isScrolling: true})
      setTimeout(that => that.setState({isScrolling: false}), 1000, this)
    } else {
      this.scrollLeft = this.scrollingElement.scrollLeft
      window.localStorage.setItem(this.scrollStorageKey, this.scrollingElement.scrollLeft)
    }
  }

  componentDidUpdate(prevProps) {
    this.scrollingElement.scrollLeft = this.scrollLeft
    if (prevProps.reservationGroups.length !== this.props.reservationGroups.length) {
      this.verticalScrollToMiddle()
    }
  }

  componentDidMount() {
    this.scrollingElement.scrollLeft = this.scrollLeft
    if (this.props.reservationGroups.length !== 0) {
      this.verticalScrollToMiddle()
    }
  }

  verticalScrollToMiddle() {
    const selector = this.scrollingElement
    const element = this.currentHour
    if (element) {
      const height = element.clientHeight
      selector.scrollTop = element.offsetTop - selector.offsetTop - height
    }
  }

  render() {
    const reservationGroups = this.props.reservationGroups
    const fieldCount = reservationGroups[0] ? reservationGroups[0][1].length : 0
    let outerStyle = null, innerStyle = null
    if (fieldCount > 6) {
      innerStyle = {width: `${fieldCount * 133}px`}
    } else {
      outerStyle = {height: "140px"}
    }
    return(
      <div className="shop-reservation__selector" onScroll={this.onScrollButtons} style={outerStyle}
        ref={(el) => this.scrollingElement = el}>
        <div style={innerStyle} >
        {
          reservationGroups.map((reservations, i) =>
            <div key={i} className={ isCurrentHour(reservations[0]) && this.state.isScrolling ?
                                     "shop-reservation__red-line" : "" }
              ref={ isCurrentHour(reservations[0]) ?
                     (element) => {this.currentHour = element} : null } >
              <div className="shop-reservation__reservation-buttons" >
                {reservations[1].map((r, i) =>
                  <ReservationButton reservation={r} key={i}
                    onClick={() => (r && this.props.onSelect(r.id))}
                    isSelected={r && this.props.selectedId === r.id} />
                )}
              </div>
            </div>
          )
        }
        </div>
      </div>
    )
  }
}

class ReservationModal extends React.Component {
  reservationName(reservation) {
    try {
      return reservation.nickname ? reservation.nickname
              : reservation.name ? reservation.name
              : this.props.players[reservation.masterPlayerId] ? this.props.players[reservation.masterPlayerId].name 
              : ''
    } catch (error) {
      return ''
    }
  }

  reservationData(ids) {
    return ids.map(id => {
      if (id) {
        const reservation = this.props.reservations[id]
        return reservation ? { id, name: this.reservationName(reservation), isOpenGame: reservation.isOpenGame } : null
      } else {
        return null
      }
    })
  }

  render() {
    const reservationGroups = this.props.reservationIdGroups.map(
                                    (el) => [el[0], this.reservationData(el[1])])
    const { onCancel, isActive, onPlayerChanged, onSelectReservation, onSubmit, reservationId, allOptionsSelected } = this.props
    return (
      <Modal
        container={document.body}
        dialogClassName="shop-reservation__dialog"
        onHide={onCancel}
        show={isActive}
      >
        <Modal.Body>
          <div className="shop-reservation">
            <Title text="Player Name"/>
            <PlayerSelector onChange={onPlayerChanged} />
            <PriceButtons />
            <Title text="Reservation"/>
            <ReservationSelector onSelect={onSelectReservation}
              selectedId={reservationId}
              reservationGroups={reservationGroups}
            />
            <div className="shop-reservation__control-buttons">
              <button className="btn btn-lg btn-default" onClick={onSubmit} disabled={!allOptionsSelected}>
                Add
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

ReservationModal.propTypes = {
  isActive: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onPlayerChanged: PropTypes.func.isRequired,
  onSelectReservation: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  players: PropTypes.object,
  reservationIdGroups: PropTypes.array,
  reservationId: PropTypes.number,
  reservations: PropTypes.object.isRequired,
  allOptionsSelected: PropTypes.bool
}

export default ReservationModal
